var fireman = (function (globalObj, $) {

	var tool = globalObj.tool = globalObj.tool || {};

	tool.init = (cb) => {
                console.log(config);
		firebase.initializeApp(config);
		cb();
	};

	tool.createUserIfDoesNotExist = (user) => {
		var userRef = firebase.database().ref('/users/' + user.uid);
		userRef.once('value')
			.then(function(snapshot) {
				var userObj			= snapshot.val();
				var permissions	= {};
				var newUser	= {};

				if (userObj !== null) {
					console.log('User ' + user.displayName + ' already exist');
					return false;
				} else {

					permissions['read']		= true;
					permissions['write']	= false;
					permissions['update']	= false;
					permissions['delete']	= false;

					newUser['name'] = user.displayName;
					newUser['email'] = user.email;
					newUser['photo'] = user.photoURL;
					console.log('Creating user ' + user.displayName);
					console.log(newUser);
					console.log(permissions);
					firebase.database().ref('/permissions/' + user.uid).set(permissions);
					firebase.database().ref('/users/' + user.uid).set(newUser);
				}
			});
	};

	tool.createNewClient = (obj) => {
		const clientsRef     = firebase.database().ref('/clients');
		const promise        = clientsRef.push(obj);
		const successTrigger = new Event('rt-clientAdded-success');
		const failedTrigger  = new Event('rt-clientAdded-failed');

		promise
			.then(e => {
				console.log('Successfully added client.');
				document.dispatchEvent(successTrigger);
			})
			.catch(e => {
				console.log(e.message);
				document.dispatchEvent(failedTrigger);
			});
	};

	tool.editClient = (clientID, obj) => {
		const clientsRef     = firebase.database().ref('/clients/' + clientID);
		const promise        = clientsRef.update(obj);
		const successTrigger = new Event('rt-clientEdited-success');
		const failedTrigger  = new Event('rt-clientEdited-failed');

		promise
			.then(e => {
				console.log('Successfully edited client: ' + clientID);
				document.dispatchEvent(successTrigger);
			})
			.catch(e => {
				console.log(e.message);
				document.dispatchEvent(failedTrigger);
			});
	};

	tool.getClient = (clientID) => {

		const clientRef     = firebase.database().ref('/clients/' + clientID);
		let data;

		clientRef.on('value', snap => {
			data = snap.val();
		});

		return data;
	};

	tool.deleteClient = (clientID) => {
		const clientRef     = firebase.database().ref('/clients/' + clientID);
		const successTrigger = new Event('rt-clientDelete-success');
		const failedTrigger  = new Event('rt-clientDelete-failed');

		if (confirm('Are you sure you want to delete this client?')) {
			const promise        = clientRef.remove();

			promise
				.then(e => {
					console.log('Successfully deleted client: ' + clientID);
					document.dispatchEvent(successTrigger);
				})
				.catch(e => {
					console.log(e.message);
					document.dispatchEvent(failedTrigger);
				});
		} else {
				// Do nothing!
		}
	};

	tool.createClientProperty = (clientID, obj) => {

		const propertyRef    = firebase.database().ref('/client_properties/' + clientID + '/properties/');
		const successTrigger = new Event('rt-propertyCreated-success');
		const failedTrigger  = new Event('rt-propertyCreated-failed');
		const promise = propertyRef.push(obj);
		const leadmakrSettings = {
			director: true,
			instance_id: '',
			campaign_id: '',
			product_id: ''
		};
		const directorSettings = {
			isActive: true,
			auth_id: 'wallapost',
			api_url: 'https://svc.itck.biz/lmakr/lead_event_action_save/'
		};

		promise
			.then(e => {
				console.log('Successfully added property: ' + obj.property_name);

				// Set Up Leadmakr Defaults
				firebase.database().ref('/leadmakr/' + e.key + '/settings/')
					.set(leadmakrSettings).then(e => {
						console.log('Successfully setup LeadMakr defaults.');
					});

				firebase.database().ref('/leadmakr_director/' + e.key + '/settings/')
					.set(directorSettings).then(e => {
						console.log('Successfully setup LeadMakr Director defaults.');
					});

				document.dispatchEvent(successTrigger);
			})
			.catch(e => {
				console.log(e.message);
				document.dispatchEvent(failedTrigger);
			});
	};

	tool.viewLmakrSetting = (clientID, propertyID, formContainer) => {
		const lMakrRef = firebase.database().ref('/leadmakr/' + propertyID + '/settings/');
		let data;
		lMakrRef.on('value', snap => {
			data = snap.val();
			if(!data.hasOwnProperty('product_id')){
				data.product_id='';
			}
			rt.tool.formUtils.editLmakrSettingsForm(formContainer,clientID, propertyID, data);
		});

		return data;
	}

	tool.editLmakrSetting = (propertyID,obj) => {
		const lMakrRef     = firebase.database().ref('/leadmakr/' + propertyID + '/settings/');
		const promise        = lMakrRef.update(obj);
		const successTrigger = new Event('rt-lmakrSettingsEdited-success');
		const failedTrigger  = new Event('rt-lmakrSettingsEdited-failed');

		promise
			.then(e => {
				console.log('Successfully edited Lmakr settings: ' + propertyID);
				document.dispatchEvent(successTrigger);
			})
			.catch(e => {
				console.log(e.message);
				document.dispatchEvent(failedTrigger);
			});
	}

	tool.viewProperty = (clientID, propertyID) => {
		const propertyRef = firebase.database().ref('/client_properties/' + clientID + '/properties/' + propertyID + '/');
		let data;

		propertyRef.on('value', snap => {
			data = snap.val();
		});

		return data;
	};

	tool.deleteProperty = (clientID, propertyID) => {
		const propertyRef = firebase.database().ref('/client_properties/' + clientID + '/properties/' + propertyID + '/');
		const lMakrRef     = firebase.database().ref('/leadmakr/' + propertyID + '/settings/');
		const directorRef = firebase.database().ref('/leadmakr_director/' + propertyID + '/settings/');
		const eventActionRef = firebase.database().ref('/leadmakr_director_actions/' + propertyID + '/actions/');

		const successTrigger = new Event('rt-propertyDelete-success');
		const failedTrigger  = new Event('rt-propertyDelete-failed');

		if (confirm('Are you sure you want to delete this property?')) {
			const promise = propertyRef.remove();

			promise
				.then(e => {
					console.log('Successfully deleted client: ' + clientID);
					lMakrRef.remove();
					directorRef.remove();
					eventActionRef.remove();
					document.dispatchEvent(successTrigger);
				})
				.catch(e => {
					console.log(e.message);
					document.dispatchEvent(failedTrigger);
				});
		} else {
				// Do nothing!
		}

		return data;
	};

	tool.editClientProperty = (clientID, propertyID, obj) => {
		const propertyRef    = firebase.database().ref('/client_properties/' + clientID + '/properties/' + propertyID);
		const successTrigger = new Event('rt-propertyEdited-success');
		const failedTrigger  = new Event('rt-propertyEdited-failed');
		const promise = propertyRef.update(obj);

		promise
			.then(e => {
				console.log('Successfully edited property: ' + obj.property_name);
				document.dispatchEvent(successTrigger);
			})
			.catch(e => {
				console.log(e.message);
				document.dispatchEvent(failedTrigger);
			});
	};

	tool.deleteClientProperty = (clientID, propertyID, obj) => {
		const propertyRef    = firebase.database().ref('/clients/' + clientID + '/properties/' + propertyID);
		const successTrigger = new Event('rt-propertyDeleted-success');
		const failedTrigger  = new Event('rt-propertyDeleted-failed');

		if (confirm('Are you sure you want to delete this property?')) {
			const promise = propertyRef.remove();
			promise
			.then(e => {
				console.log('Successfully deleted property: ' + obj.property_name);
				document.dispatchEvent(successTrigger);
			})
			.catch(e => {
				console.log(e.message);
				document.dispatchEvent(failedTrigger);
			});
		}
	};

	// Creates a LeadMakr Call Scheduler Event Action
	tool.LeadMakr = {
		director: {
			viewAction: (clientID, propertyID, actionID) => {
				const actionRef = firebase.database().ref('/leadmakr_director_actions/' + propertyID + '/actions/' + actionID);
				let data;

				actionRef.on('value', snap => {
					data = snap.val();
				});

				return data;
			},
			createAction: (clientID, propertyID, eventActionobj) => {
				const eventActionRef = firebase.database().ref('/leadmakr_director_actions/' + propertyID + '/actions/');
				const promise        = eventActionRef.push(eventActionobj);
				const successTrigger = new Event('rt-eventActionCreated-success');
				const failedTrigger  = new Event('rt-eventActionCreated-failed');

				promise
					.then(e => {
						console.log('Successfully added event: ' + eventActionobj.event_label);
						document.dispatchEvent(successTrigger);
					})
					.catch(e => {
						console.log(e.message);
						document.dispatchEvent(failedTrigger);
					});
			},
			updateAction: (clientID, propertyID, actionID, actionPayloadObj) => {
				const eventActionRef = firebase.database().ref('/leadmakr_director_actions/' + propertyID + '/actions/' + actionID + '/');
				const promise        = eventActionRef.set(actionPayloadObj);
				const successTrigger = new Event('rt-actionEdited-success');
				const failedTrigger  = new Event('rt-actionEdited-failed');

				promise
					.then(e => {
						console.log('Successfully updated event: ' + actionPayloadObj.action_label);
						document.dispatchEvent(successTrigger);
					})
					.catch(e => {
						console.log(e.message);
						document.dispatchEvent(failedTrigger);
					});
			},
			deleteAction: (clientID, propertyID, eventActionID) => {
				const eventActionRef = firebase.database().ref('/clients/' + clientID + '/properties/' + propertyID + '/services/leadmakr/call_scheduler/event_actions/' + eventActionID);
				const successTrigger = new Event('rt-eventActionDeleted-success');
				const failedTrigger  = new Event('rt-eventActionDeleted-failed');

				if (confirm('Are you sure you want to delete this event action?')) {
					const promise        = eventActionRef.remove();
					promise
					.then(e => {
						console.log('Successfully deleted event: ' + eventActionID);
						document.dispatchEvent(successTrigger);
					})
					.catch(e => {
						console.log(e.message);
						document.dispatchEvent(failedTrigger);
					});
				}
				else{
					// Do nothing
				}
			},
			deleteActionCustomFields: (clientID, propertyID, actionID) => {
				const customFieldRef = firebase.database().ref('/leadmakr_director_actions/' + propertyID + '/actions/' + actionID + '/custom_field_rules');
				customFieldRef.remove()
					.then(function() {
						console.log('Remove succeeded.')
					})
					.catch(function(error) {
						console.log('Remove failed: ' + error.message)
					});
			}
		}
	};

	tool.init(function () {
		console.log('Framework has loaded.');
	});

	return globalObj;
}(fireman || {}, jQuery));
